<script lang="ts">
  import { i18n } from "../i18n.svelte";
  import { inview } from "../actions";
  import SectionHead from "./SectionHead.svelte";
  import Sprout from "./Sprout.svelte";

  const h = $derived(i18n.t.how);
</script>

<section class="section section--rule" id="how">
  <div class="container">
    <SectionHead label={h.label} title={h.title} lead={h.lead} align="center" />

    <div class="flow reveal" use:inview aria-hidden="true">
      <svg viewBox="0 0 720 70">
        <path
          d="M40 52 C 200 52 230 30 360 30 S 540 14 680 14"
          fill="none"
          stroke="var(--sprout)"
          stroke-width="2"
          stroke-dasharray="2 7"
          stroke-linecap="round"
        />
        <circle cx="40" cy="52" r="5" fill="var(--paper-card)" stroke="var(--green)" stroke-width="2.5" />
        <circle cx="360" cy="30" r="6" fill="var(--paper-card)" stroke="var(--green)" stroke-width="2.5" />
        <circle cx="680" cy="14" r="7" fill="var(--green)" stroke="var(--green)" stroke-width="2.5" />
      </svg>
    </div>

    <ol class="steps">
      {#each h.steps as step, i}
        <li class="step reveal card" use:inview={{ delay: i * 110 }}>
          <span class="num">{String(i + 1).padStart(2, "0")}</span>
          <span class="seed"><Sprout size={48} stage={(i + 2) as 2 | 3 | 4} soil /></span>
          <span class="kanji">{step.k}</span>
          <h3>{step.t}</h3>
          <p>{step.d}</p>
        </li>
      {/each}
    </ol>
  </div>
</section>

<style>
  .flow {
    margin: clamp(2rem, 1.5rem + 2vw, 3rem) auto 0;
    max-width: 880px;
    padding-inline: 4%;
  }
  .flow svg {
    width: 100%;
    height: auto;
    overflow: visible;
  }
  .steps {
    margin-top: 1.4rem;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.2rem;
    counter-reset: step;
  }
  .step {
    position: relative;
    padding: 2rem 1.6rem 1.8rem;
    overflow: hidden;
  }
  .num {
    font-family: var(--font-mono);
    font-size: 0.8rem;
    letter-spacing: 0.1em;
    color: var(--terra);
  }
  .seed {
    display: block;
    margin: 1rem 0 0.4rem;
  }
  .kanji {
    position: absolute;
    top: 1rem;
    right: 1.2rem;
    font-family: var(--font-mincho);
    font-size: 3.4rem;
    line-height: 1;
    color: var(--sprout-soft);
    pointer-events: none;
  }
  h3 {
    font-size: var(--fs-h3);
    margin-top: 0.6rem;
  }
  p {
    margin-top: 0.7rem;
    color: var(--ink-soft);
    font-size: 0.96rem;
    line-height: 1.85;
  }

  /* connecting dotted line between cards on wide screens */
  @media (min-width: 781px) {
    .steps {
      position: relative;
    }
  }
  @media (max-width: 780px) {
    .steps {
      grid-template-columns: 1fr;
    }
  }
</style>
